__turbopack_context__.v({
  "affixWrapper": "lindex-module-scss-module__UlfaTa__affixWrapper",
});
